module.exports = __webpack_public_path__ + "static/media/bookmark.0d99030a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/navbar/bookmark.svg
// module id = 2241
// module chunks = 0